/* eslint-disable no-unused-vars,valid-jsdoc */
import { Interface, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

namespace('Ofcs.Editor.Item');

/**
 * The canvas is the foundation object of all drawable objects. It provides
 * an API for the editor for drawing operations and the view objects.
 *
 * This is the interface definition of the canvas classes.
 *
 * @interface Ofcs.Editor.Item.ItemInterface
 */
export default window.Ofcs.Editor.Item.ItemInterface = new Interface({

    /**
     * Defines that item causes collisions
     * @property {boolean} supportsCollisions
     */
    supportsCollisions: false,

    /**
     * Defines that item causes bidirectional collisions
     * Use when safety margins are not distributed equally around item
     * @property {boolean} supportsCollisions
     */
    supportsBidirectionalCollisions: false,

    /**
     * Defines that item collisions include safety margins.
     * @property {boolean} supportsMarginCollisions
     */
    supportsMarginCollisions: true,

    /**
     * Defines that item causes collisions with foam
     * @property {boolean} supportsOutOfFoam
     */
    supportsOutOfFoam: false,

    /**
     * Defines that item stays within table bounds
     *
     * possible values:
     * edge - will allow item bag to touch table edges
     * inside - will keep bag and margin inside of table bounds
     *
     * @property {String} supportsInsideTable
     */
    supportsInsideTable: '',

    /**
     * Defines that item can be aligned on guides
     * @property {boolean} supportsCollisions
     */
    supportsGuides: false,

    /**
     * Defines that item is rotateable
     * @property {boolean} supportsRotation
     */
    supportsRotation: false,

    /**
     * Defines that item is able to be rotated initially (not visible to user)
     * @property {boolean} supportsInitialRotation
     */
    supportsInitialRotation: false,

    /**
     * Defines that item width is resizeable
     * @property {boolean} supportsWidth
     */
    supportsWidth: false,

    /**
     * Defines that item height is resizeable
     * @property {boolean} supportsHeight
     */
    supportsHeight: false,

    /**
     * Defines that item is positionable
     * @property {boolean} supportsPositioning
     */
    supportsPositioning: false,

    /**
     * Defines that item has depth
     * @property {boolean} supportsDepth
     */
    supportsDepth: false,

    /**
     * Defines that item supports flipping
     * @property {boolean} supportsFlipping
     */
    supportsFlipping: false,

    /**
     * Defines that item supports align
     * @property {boolean} supportsAlign
     */
    supportsAlign: false,

    /**
     * Defines that an item supports covers
     * @property {boolean} supportsOptions
     */
    supportsCover: false,

    /**
     * Defines that an item supports sealing
     * @property {boolean} supportsSealing
     */
    supportsSealing: false,

    /**
     * Defines that an item can be moved
     * @property {boolean} supportsMove
     */
    supportsMove: true,

    /**
     * Defines that an item can be copied
     * @property {boolean} supportsCopying
     */
    supportsCopying: true,

    /**
     * Defines that an item can be selected
     * amongst other items
     * @property {boolean} supportsMultiselection
     */
    supportsMultiselection: true,

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getBounds() {},

    /**
     * Returns a transformation matrix for the current rotation and position
     *
     * @return {Matrix} Transformation matrix
     */
    getMatrix() {},

    /**
     * Calculate the rotation by considering the initial rotation
     *
     * @return {number}
     */
    getNormalizedRotation() {},

    /**
     * Add a validator to the item.
     *
     * @param {ValidatorInterface} validator
     */
    addValidator(validator) {},

    /**
     * Check if one of the given properties has changed
     *
     * @param {...string} properties
     * @return {boolean}
     */
    hasChangedProperty(...properties) {},
});
